import { useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { CustomerEditForm } from '../../../components/dashboard/create/create-user';
import { gtm } from '../../../lib/gtm';

const CreateUser = () => {
  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <Box component="main" sx={{ flexGrow: 1, pt: 10, pb: 4 }}>
      <Container maxWidth="md">
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>
          Créer un apprenant
        </Typography>
        <CustomerEditForm />
      </Container>
    </Box>
  );
};

export default CreateUser;
